import React, { useEffect } from 'react'

function MainSlideCard({data}) {
   
  return (
    <div className='relative w-full h-[600px] max-[1000px]:h-full min-h-[200px]'>
        <img className='w-full h-full min-h-full' src={data?.image_full_url} />
        <div  className='absolute bg-black/40 w-full h-full top-0 left-0 flex justify-center items-center flex-col'>
            <h1 className='text-white text-[58px] font-[800] max-w-[800px] text-center max-[1000px]:text-[48px] max-[700px]:text-[38px] max-[500px]:text-[28px] max-[400px]:text-[24px] max-[300px]:text-[20px]'>{data?.translate?.title}</h1>
            <p className='text-white mt-[20px] max-[500px]:mt-[0] text-[25px] max-w-[700px] text-center max-[1000px]:text-[20px] max-[700px]:text-[16px] max-[500px]:text-[14px] max-[300px]:text-[12px]'>{data?.translate?.text}</p>
        </div>
    </div>
  )
}

export default MainSlideCard